import RegistrationAccountStatus, {
  type RegistrationAccountStatus as RegistrationAccountStatusType,
} from '@/_constants/RegistrationAccountStatus.ts';
import { RegistrationFlowContext, type RegistrationDraft } from '@/context/registrationFlowContext.ts';
import { type PropsWithChildren, useCallback, useMemo, useState } from 'react';

const RegistrationFlow = ({ children }: PropsWithChildren) => {
  const [draftUser, setDraftUser] = useState<RegistrationDraft | null>(null);
  const [accountStatus, setAccountStatus] = useState<RegistrationAccountStatusType>(
    RegistrationAccountStatus.REGISTERING
  );
  const [token, setRegistrationToken] = useState<string | null>(null);

  const setToken = useCallback((newToken: string) => {
    setRegistrationToken(newToken);
  }, []);

  const setStatus = useCallback((newStatus: RegistrationAccountStatusType) => {
    setAccountStatus(newStatus);
  }, []);

  const saveDraft = useCallback((user: RegistrationDraft) => {
    setDraftUser(user);
  }, []);

  const clearFlow = useCallback(() => {
    setAccountStatus(RegistrationAccountStatus.REGISTERING);
    setDraftUser(null);
    setRegistrationToken(null);
  }, []);

  const contextValue = useMemo(
    () => ({ draftUser, accountStatus, token, saveDraft, setStatus, clearFlow, setToken }),
    [draftUser, accountStatus, token, saveDraft, setStatus, clearFlow, setToken]
  );

  return <RegistrationFlowContext.Provider value={contextValue}>{children}</RegistrationFlowContext.Provider>;
};

export default RegistrationFlow;
